import * as modalTypes from "../../../constants/modalTypes";
import * as objectTypes from "../../../constants/objectTypes";
import * as optionHelper from "../../../helpers/optionHelper";
import * as propertyConstants from "../../../constants/propertyConstants";
import * as tableConstants from "../../../constants/tableConstants";

import React, { Component } from "react";
import {
    SpectroType,
    createEmptySpectroType,
    generateSpectroTypeData,
    generateSpectroTypeHeadings
} from "../../../types/spectroType";
import { ModalProperties } from "../../../types/modalProperties";
import { TableContainer } from "../../Table";
import { TableHeading } from "../../../types/tableHeading";
import { t as translate } from "react-i18nify";

type Props = {
    modalId?: number;
    tableConstant: string;
    objectType: objectTypes.ObjectType;
    dataPrivileges: any;
    loading: boolean;
    allList: Array<SpectroType>;
    activeList: Array<SpectroType>;
    columnOrder: Array<propertyConstants.Property>;
    columnVisibility: Record<propertyConstants.Property, boolean>;
    columnWidth: Record<propertyConstants.Property, number>;
    offset: number;
    page: number;
    rowCount: number;
    search: string | null;
    searchParams: Record<propertyConstants.Property, string>;
    sortingAsc: boolean;
    sortingCriterion: propertyConstants.Property;
    totalCount: number | null;
};

export class SpectroTypeTable extends Component<Props> {
    generateTableHeadings = (): Array<TableHeading> => {
        const tableVisibleColumns = optionHelper.handleTableHeadingVisibility(
            [propertyConstants.PROPERTY_NAME],
            this.props.columnVisibility
        );

        return generateSpectroTypeHeadings(
            this.props.objectType,
            tableVisibleColumns,
            tableVisibleColumns,
            [],
            [propertyConstants.PROPERTY_NAME],
            [propertyConstants.PROPERTY_NAME],
            tableConstants.EMPTY_COLUMN_WIDTH
        );
    };

    generateAddModalParams = (): any => {
        const { objectType } = this.props;

        return {
            title: translate("spectro.addSpectroType"),
            dataPrivileges: this.props.dataPrivileges,
            objectType: objectType,
            type: modalTypes.ADD_MODAL,
            data: createEmptySpectroType(),
            headings: generateSpectroTypeHeadings(
                objectType,
                [propertyConstants.PROPERTY_NAME],
                [propertyConstants.PROPERTY_NAME],
                [propertyConstants.PROPERTY_NAME],
                [propertyConstants.PROPERTY_NAME],
                [propertyConstants.PROPERTY_NAME],
                tableConstants.EMPTY_COLUMN_WIDTH
            )
        };
    };

    generateEditModalParams = (): any => {
        const { activeList, objectType } = this.props;

        const activeData = generateSpectroTypeData(activeList);

        if (activeData.length) {
            return {
                title: translate("fileCategory.editSpectroType"),
                type: modalTypes.EDIT_MODAL,
                objectType: objectType,
                data: activeData[0],
                headings: generateSpectroTypeHeadings(
                    objectType,
                    [propertyConstants.PROPERTY_NAME],
                    [propertyConstants.PROPERTY_NAME],
                    [propertyConstants.PROPERTY_NAME],
                    [propertyConstants.PROPERTY_NAME],
                    [propertyConstants.PROPERTY_NAME],
                    tableConstants.EMPTY_COLUMN_WIDTH
                )
            };
        }

        return null;
    };

    render(): JSX.Element {
        const modalProperties: ModalProperties = {
            addModalType: modalTypes.MODAL_SPECTRO_TYPE_ADD,
            addModalParams: this.generateAddModalParams(),
            editModalType: modalTypes.MODAL_SPECTRO_TYPE_EDIT,
            editModalParams: this.generateEditModalParams()
        };

        return (
            <div className="height-100">
                <TableContainer
                    className={"table-with-filter"}
                    tableConstant={this.props.tableConstant}
                    objectType={this.props.objectType}
                    modalId={this.props.modalId}
                    dataPrivileges={this.props.dataPrivileges}
                    loading={this.props.loading}
                    headings={this.generateTableHeadings()}
                    data={generateSpectroTypeData(this.props.allList)}
                    activeData={this.props.activeList}
                    totalCount={this.props.totalCount}
                    offset={this.props.offset}
                    page={this.props.page}
                    search={this.props.search}
                    searchParams={this.props.searchParams}
                    sortingAsc={this.props.sortingAsc}
                    sortingCriterion={this.props.sortingCriterion}
                    rowCount={this.props.rowCount}
                    showFilterRow={false}
                    showGlobalSearch={true}
                    modalProperties={modalProperties}
                />
            </div>
        );
    }
}
